import React from 'react';
import { useState , useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import axiosInstance from './interceptors/axios';
import Cookies from 'js-cookie';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import NotFound from './components/NotFound';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [canRender, setCanRender] = useState(false);
  const [email, setEmail] = useState("");


  useEffect(() => {
    async function fetchData() {
    const access_token = Cookies.get('access_token');
    if (access_token) {
      const requestData = { regybox_token: Cookies.get('regybox_token') };
      try{
          const response = await axiosInstance.get('/protected' , { params: requestData });
          if (response.status === 200) {
            setIsLoggedIn(true);
            setEmail(response.data.email);
          }
      }
      catch (error) {
          console.log(error.response);
      }
    }
    setCanRender(true);
  }

  fetchData();
}, []);

  return (
    <div className="background">
    {canRender === true && (
      <Router>
        {isLoggedIn && <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} email={email}/>}
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<NotFound/>} />
          <Route path="/login" element={<Login isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} setEmail={setEmail}/>} />
          <Route path="/dashboard/*" element={<Dashboard isLoggedIn={isLoggedIn}/>} />
        </Routes>
      </Router>
    )}
    </div>
  );
}

export default App;
